/**
 * Created by tyler.carruth on 10/4/16.
 */
angular
    .module('vppApp')
    .factory('googleMapsFactory', googleMapsFactory);

googleMapsFactory.$inject = ['$q', '$rootScope'];

function googleMapsFactory($q, $rootScope) {
// app.factory('googleMaps', ['$q', '$rootScope', function ($q, $rootScope) {

    var factory = {};
    var places = [];
    var placesIteration = 0;

    var geocoder = new google.maps.Geocoder();

    factory.zipToLocation = function(zipCode) {
        console.log('zipToLocation()', zipCode);
        var deferred = $q.defer();

        geocoder.geocode( { 'address': zipCode }, function(results, status) {
            if (status == google.maps.GeocoderStatus.OK) {
                //Got result, center the map and put it out there
                /*map.setCenter(results[0].geometry.location);
                var marker = new google.maps.Marker({
                    map: map,
                    position: results[0].geometry.location
                });*/
                // return results[0].geometry.location;
                deferred.resolve(results[0].geometry.location);
            } else {
                console.log("Geocode result status: " + status);
                deferred.resolve(results[0].geometry.location);
            }
        });

        return deferred.promise;
    }

    factory.getPlaces = function(map, coords, area, interests, max) {
        var deferred = $q.defer();
        var i;
        var service = new google.maps.places.PlacesService(map);
        service.nearbySearch({location : coords, radius : area, types : interests}, function(results, status, pagination) {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
                for (i = 0; i < results.length; i++) {
                    places.push(results[i]);
                }
                if(pagination.hasNextPage && placesIteration < max-1) {
                    placesIteration++;
                    pagination.nextPage();
                } else {
                    $rootScope.$apply(function() {
                        deferred.resolve(places);
                    });
                    placesIteration = 0;
                    places = [];
                }
            } else if (status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                deferred.reject('Nothing Found');
            } else {
                deferred.reject('Service Unavailable');
            }
        });
        return deferred.promise;
    };

    factory.getPlaceDetail = function(map, id) {
        var deferred = $q.defer();
        var service = new google.maps.places.PlacesService(map);
        service.getDetails({placeId : id}, function(results, status) {
            if (status == google.maps.places.PlacesServiceStatus.OK) {
                if (results.photos) {
                    for (var i = 0; results.photos.length > i; i++) {
                        results.photos[i].photoSmall = results.photos[i].getUrl({'maxWidth': 100, 'maxHeight': 100});
                        results.photos[i].photoBig = results.photos[i].getUrl({'maxWidth': 600, 'maxHeight': 600});
                    }
                }
                results.overlayImage = false;
                results.overlayRatings = false;
                $rootScope.$apply(function() {
                    deferred.resolve(results);
                });
            } else if (status == google.maps.places.PlacesServiceStatus.ZERO_RESULTS) {
                deferred.reject({error : 'Nothing Found'});
            } else {
                deferred.reject({error : 'Service Unavailable'});
            }
        });
        return deferred.promise;
    };

    return factory;
}